import { Autocomplete, Box, Checkbox, Chip, Paper, TextField } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  calendarFilterCheckboxSx,
  calendarFilterCountChipSx,
  calendarFilterAutocompleteSx,
  calendarFilterTextFieldSx,
} from './filterStyles';
import { sortSelectedToTop } from './filterUtils';

const FixedWidthPaper = styled(Paper)(() => ({
  width: 220,
}));

FacilityFilter.propTypes = {
  facilities: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.number })),
  facilityFilter: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.number })),
  handleFacilityChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export function FacilityFilter({ facilities, facilityFilter, handleFacilityChange, isLoading = false }) {
  const [displayedOptions, setDisplayedOptions] = useState(facilities);

  useEffect(() => {
    setDisplayedOptions(facilities);
  }, [facilities]);

  const handleOpen = () => {
    setDisplayedOptions(sortSelectedToTop(facilities, facilityFilter));
  };

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      openOnFocus
      options={displayedOptions}
      onOpen={handleOpen}
      loading={isLoading}
      value={facilityFilter}
      onChange={handleFacilityChange}
      popupIcon={<KeyboardArrowDownIcon sx={{ color: '#707070', fontSize: 16 }} />}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option.value}>
          <Checkbox sx={calendarFilterCheckboxSx} checked={selected} />
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          sx={calendarFilterTextFieldSx}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <Box
                className="filter-autocomplete-adornment"
                sx={{ display: 'flex', alignItems: 'center', pointerEvents: 'none' }}
              >
                <Box component="span" sx={{ fontSize: '14px', color: '#707070' }}>
                  Facilities
                </Box>
                {facilityFilter.length > 0 ? (
                  <Chip label={facilityFilter.length} size="small" sx={{ ...calendarFilterCountChipSx, ml: '8px' }} />
                ) : null}
              </Box>
            ),
          }}
        />
      )}
      ListboxProps={{ sx: calendarFilterAutocompleteSx }}
      PaperComponent={FixedWidthPaper}
      sx={{
        ...calendarFilterAutocompleteSx,
        minWidth: 136,
        maxWidth: 136,
        ml: 2,
      }}
    />
  );
}
